import { render, staticRenderFns } from "./UpdatePermission.vue?vue&type=template&id=2959e792&"
import script from "./UpdatePermission.vue?vue&type=script&lang=js&"
export * from "./UpdatePermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports